import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import TitlesPage from "./pages/TitlesPage";
import MovieShowDetailsPage from "./pages/MovieShowDetailsPage";
import PersonPage from "./pages/PersonPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/titles-page" element={<TitlesPage />} />
        <Route path="/movieShowDetailsPage/:id" element={<MovieShowDetailsPage />} />
        <Route path="/personPage/:id" element={<PersonPage />} />
      </Routes>
    </Router>
  );
}

export default App;
